import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "admin-page common-page"
};
const _hoisted_2 = {
  class: "page-title"
};
const _hoisted_3 = {
  class: "admin-table"
};
import { ref, markRaw } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import useRoleStore from '@/store/modules/role';
import { storeToRefs } from 'pinia';
import { deleteAccoutApi, updateRoleStatusApi } from '@/service/modules/role';
import { ElMessage, ElMessageBox } from 'element-plus';
import { QuestionFilled } from '@element-plus/icons-vue';
import protoPagination from '@/components/proto-pagination.vue';
import adminDialog from './components/admin-dialog.vue';
import adminPasswordDialog from './components/admin-password-dialog.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'admin',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const roleStore = useRoleStore();
    const page = ref({
      current: 1,
      size: 10
    });
    const {
      allAdminList,
      allRoleList,
      allAdminTotal: total
    } = storeToRefs(roleStore);
    const adminDialogVisible = ref(false);
    const adminDialogType = ref('add');
    const adminDialogData = ref({});
    const adminPasswordVisible = ref(false);
    const adminPassworDialogData = ref({});
    initListData();
    async function initListData() {
      roleStore.allAdminList = [];
      roleStore.allAdminTotal = 0;
      await roleStore.getAllRoleListAction();
      await roleStore.getAllAdminListAction(page.value);
    }
    async function restAdminList() {
      page.value.current = 1;
      initListData();
    }
    function handleAdminTableItem(item) {
      adminDialogData.value = item;
      adminDialogType.value = 'edit';
      adminDialogVisible.value = true;
      console.log('adminDialogData', adminDialogData.value);
    }
    function handleAccoutPassword(item) {
      adminPassworDialogData.value = item;
      adminPasswordVisible.value = true;
    }
    function deleteAdminTableItem(id) {
      ElMessageBox.confirm('此操作将永久删除该数据, 是否继续？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        icon: markRaw(QuestionFilled)
      }).then(async () => {
        try {
          let res = await deleteAccoutApi({
            uid: id
          });
          ElMessage.success('删除成功');
          restAdminList();
        } catch {}
      }).catch(() => {});
    }
    async function handleAdminTableCurrentChange(val) {
      page.value.current = val;
      await roleStore.getAllAdminListAction(page.value);
    }
    // 账号状态启用/禁用
    async function handleTableSattusChange(val) {
      let query = {
        uid: val.uid,
        status: Number(val.status)
      };
      try {
        let res = await updateRoleStatusApi(query);
        ElMessage.success('操作成功');
        page.value.current = 1;
        await roleStore.getAllAdminListAction(page.value);
      } catch {}
    }
    // 映射角色中文名
    function getRoleName(roleId) {
      let item = allRoleList.value.find(row => {
        return row.id === roleId;
      });
      if (item) return item.roleName;
    }
    // 增加、修改账号
    function handleAdminDialog() {
      adminDialogType.value = 'add';
      adminDialogVisible.value = true;
    }
    function closeAdminDialog() {
      adminDialogVisible.value = false;
    }
    function closeAdminPasswordDialog() {
      adminPasswordVisible.value = false;
      adminPassworDialogData.value = {};
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createTextVNode("账号管理 ")), _createVNode(_component_el_button, {
        onClick: handleAdminDialog,
        type: "primary",
        style: {
          "margin-left": "5px"
        }
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("新增")])),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_table, {
        data: _unref(allAdminList),
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        }
      }, {
        empty: _withCtx(() => _cache[5] || (_cache[5] = [_createElementVNode("div", {
          class: "table-empty"
        }, [_createElementVNode("img", {
          class: "no-data",
          src: _imports_0,
          alt: ""
        }), _createElementVNode("div", {
          class: "empty-text"
        }, "暂无数据")], -1)])),
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "序号",
          width: "70"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.$index + 1 + (page.value.current - 1) * page.value.size), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "username",
          label: "名称",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "realname",
          label: "真实姓名",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "mobile",
          label: "手机号码",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "角色",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(getRoleName(Number(scope.row.roleId))), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "是否启用",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_switch, {
            modelValue: scope.row.status,
            "onUpdate:modelValue": $event => scope.row.status = $event,
            "active-value": 1,
            disabled: scope.row.uid === 1,
            "inactive-value": 0,
            onChange: $event => handleTableSattusChange(scope.row)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            class: "m-r-10",
            onClick: $event => handleAdminTableItem(scope.row),
            type: "primary",
            disabled: scope.row.uid === 1
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("编辑")])),
            _: 2
          }, 1032, ["onClick", "disabled"]), _createVNode(_component_el_link, {
            class: "m-r-10",
            onClick: $event => handleAccoutPassword(scope.row),
            type: "warning",
            disabled: scope.row.uid === 1
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("修改密码")])),
            _: 2
          }, 1032, ["onClick", "disabled"]), _createVNode(_component_el_link, {
            type: "danger",
            onClick: $event => deleteAdminTableItem(scope.row.uid),
            disabled: scope.row.uid === 1
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("删除")])),
            _: 2
          }, 1032, ["onClick", "disabled"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createVNode(protoPagination, {
        page: page.value,
        total: _unref(total),
        onCurrentChange: handleAdminTableCurrentChange
      }, null, 8, ["page", "total"])]), _createVNode(adminDialog, {
        "dialog-visible": adminDialogVisible.value,
        "dialog-type": adminDialogType.value,
        "item-data": adminDialogData.value,
        onCloseDialog: closeAdminDialog,
        onRestData: restAdminList
      }, null, 8, ["dialog-visible", "dialog-type", "item-data"]), _createVNode(adminPasswordDialog, {
        "dialog-visible": adminPasswordVisible.value,
        "item-data": adminPassworDialogData.value,
        onCloseDialog: closeAdminPasswordDialog,
        onRestData: restAdminList
      }, null, 8, ["dialog-visible", "item-data"])]);
    };
  }
});